export const AssetTableColumns = {
  GROUP_COLUMNS: 'Columns',
  ASSETS: 'Assets',
  PRODUCTION: 'Production',
  LOST_PRODUCTION: 'Lost Production',
  CONTRACTUAL_AVAILABILITY: 'Contractual Availability',
  ASSET_TOTAL: 'Total',
};

export const AssetTableDefs = {
  [AssetTableColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'asset_table.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [AssetTableColumns.ASSETS]: {
        locked: true,
        labels: [
          {
            a11yKey: 'asset_table.asset',
            a11yDefault: 'Assets',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [AssetTableColumns.PRODUCTION]: {
        labels: [
          {
            a11yKey: 'asset_table.production',
            a11yDefault: 'Production',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [AssetTableColumns.LOST_PRODUCTION]: {
        labels: [
          {
            a11yKey: 'asset_table.lost_production',
            a11yDefault: 'Lost Production',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [AssetTableColumns.CONTRACTUAL_AVAILABILITY]: {
        locked: true,
        labels: [
          {
            a11yKey: 'asset_table.contractual_availability',
            a11yDefault: 'Contractual Availability',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const AssetTableDefaultCols = [
  {
    id: AssetTableColumns.GROUP_COLUMNS,
    cols: [
      {
        id: AssetTableColumns.ASSETS,
        visible: true,
      },
      {
        id: AssetTableColumns.PRODUCTION,
        visible: true,
      },
      {
        id: AssetTableColumns.LOST_PRODUCTION,
        visible: true,
      },
      {
        id: AssetTableColumns.CONTRACTUAL_AVAILABILITY,
        visible: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
